import { Injectable } from '@angular/core';
import { Category, Suggestion, SuggestionTypes } from '~app/modules/generic/models';

@Injectable({
  providedIn: 'root'
})
export class SuggestionTermUtilService {

  public isCategory(term: Suggestion) {
    return term.type === SuggestionTypes.category;
  }

  public isText(term: Suggestion) {
    return !term.type || term.type === SuggestionTypes.text;
  }

  public toCategoryObject(term: Suggestion): Category {
    const category = new Category();
    category.id = term.attrs.id.toString();
    category.name = term.value;
    category.slug = term.attrs.slug;
    return category;
  }
}
